export default "__VITE_ASSET__CZK6c_c1__"